import { useState } from "react";
import { Box } from "@mui/material";
import EmiCalculation from "./emiCalculation/EmiCalculation";
import LoanDetailsComponent from "./loanDetails/LoanDetails";
import DocumentChecklist from "../preOnboarding/documentChecklist/DocumentChecklist";
import PreOnboarding from "../preOnboarding";
import { PreOnboardingProvider } from "../../contexts/PreOnboardingContext";

const defaultForm = {
  cibilScore: "",
  city: "",
  batteryType: "",
  downpayment: "",
  tenure: "",
  financer: "",
};

const EmiCalculator = () => {
  const [emiResult, setEmiResult] = useState(null);
  const [activeStep, setActiveStep] = useState(1);

  const [isCibilDialogOpen, setIsCibilDialogOpen] = useState(true);
  const [cibilScoreInput, setCibilScoreInput] = useState("");

  const [emiFormData, setEmiFormData] = useState(defaultForm);

  const resetCalculator = () => {
    setActiveStep(1);
    setEmiFormData({ ...defaultForm, cibilScore: cibilScoreInput });
    setEmiResult(null);
  };

  return (
    <PreOnboardingProvider>
      <Box>
        {activeStep === 1 && (
          <EmiCalculation
            formData={emiFormData}
            setFormData={setEmiFormData}
            emiResult={emiResult}
            setEmiResult={setEmiResult}
            isCibilDialogOpen={isCibilDialogOpen}
            setIsCibilDialogOpen={setIsCibilDialogOpen}
            cibilScoreInput={cibilScoreInput}
            setCibilScoreInput={setCibilScoreInput}
            setActiveStep={setActiveStep}
          />
        )}
        {activeStep === 2 && (
          <LoanDetailsComponent
            loanData={emiResult}
            setActiveStep={setActiveStep}
          />
        )}

        {activeStep === 3 && (
          <DocumentChecklist
            setActiveStep={setActiveStep}
            financierType={emiFormData.financer}
          />
        )}

        {activeStep === 4 && (
          <PreOnboarding
            setActiveStep={setActiveStep}
            financierType={emiFormData.financer}
            emiResult={emiResult}
            resetCalculator={resetCalculator}
          />
        )}
      </Box>
    </PreOnboardingProvider>
  );
};

export default EmiCalculator;
